import * as React from 'react';
import { connect } from 'react-redux';
import {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion
} from '../../../../actions/publicacionesActions';
import { DropDownArrow, customStyle } from "../../../../template/CustomStyle";
import { currencyFormat } from '../../../../helper/publicacionHelper';
import { fetchRebate } from '../../../../actions/rebatesActions';
import Select from 'react-select';
import Rebate from './Rebate';


class PrecioPago extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rebate: this.props.rebate
        }
    }

    myChangeHandler = (event) => {

        let publicacion = { ...this.props.publicacion };

        let isMoney = event.target.name == "precioPromocional" || event.target.name == "precioLista";
        if (isMoney) {
            publicacion[event.target.name] = currencyFormat(event.target.value);
        } else {
            publicacion[event.target.name] = event.target.value;
        }

        this.props.editPublicacion(publicacion);
    }

    selectSearchHandler = (options, config) => {
        let publicacion = { ...this.props.publicacion };
        publicacion[config.name] = options.value;
        this.props.editPublicacion(publicacion);
    }

    updateDataRebate = (id) => {
        this.props.fetchRebate(id)
        this.setState({ rebate: this.props.rebate })
    }

    onSelectSearchInputTipo = () => {
        this.props.fetchTiposPublicacion(this.props.publicacion.idSeller);
    }

    render() {

        const fetchComision = () => {
            if (this.props.tiposPublicacion != undefined) {
                let tipoArray = this.props.tiposPublicacion.filter((tipo) => {
                    return tipo.codigo == parseInt(this.props.publicacion.idTipoPublicacion)
                });
                return (tipoArray.length > 0) ? tipoArray.shift().comision : 0;
            }
        }

        let tipoVal = null;
        let listaTipo = [];

        if (this.props.tiposPublicacion != undefined) {
            this.props.tiposPublicacion.map((tipo) => {
                if (tipo.codigo == this.props.publicacion.idTipoPublicacion) {
                    tipoVal = { label: tipo.descripcion, value: tipo.codigo.toString() }
                }
                listaTipo.push({ label: tipo.descripcion, value: tipo.codigo.toString() })
            })
        }

        let tiposPublicacionOptions = null;
        let tipoPublicacion = "";
        if (this.props.tiposPublicacion != undefined) {
            tiposPublicacionOptions = this.props.tiposPublicacion.map((tipo, index) => {
                return <option key={index} value={tipo.codigo}>{tipo.descripcion}</option>
            })
        }

        tipoPublicacion = this.props.publicacion.tipoPublicacion ? this.props.publicacion.tipoPublicacion.descripcion : "";

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">

                    <div className="col-12 col-md-6 form-group">
                        <label>Precio Lista</label>
                        <input
                            type="text"
                            id="inputDinero1"
                            className="form-control"
                            disabled={this.props.userType.isAdminMod}
                            value={this.props.publicacion.precioLista}
                            onChange={this.myChangeHandler}
                            name="precioLista"
                        />
                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label>Precio Oferta</label>
                        <input
                            type="text"
                            id="inputDinero2"
                            className="form-control"
                            disabled={this.props.userType.isAdminMod}
                            value={this.props.publicacion.precioPromocional}
                            onChange={this.myChangeHandler}
                            name="precioPromocional"
                        />
                    </div>

                    <div className="col-12 col-md-6">
                        <label>Tipo de publicacion</label>
                        {
                            this.props.userType.isAdminMod ?
                            <input
                                disabled
                                defaultValue=""
                                className="form-control"
                                id="inlineFormCustomSelect"
                                value={tipoPublicacion}
                                name="idTipoPublicacion"
                            />
                            :
                            <Select
                                name="idTipoPublicacion"
                                value={tipoVal}
                                options={listaTipo}
                                onChange={this.selectSearchHandler}
                                onInputChange={this.onSelectSearchInputTipo}
                                styles={customStyle}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                            />
                        }
                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label>Comisión</label>
                        <input
                            type="number"
                            disabled={this.props.userType.isAdminMod}
                            className="form-control"
                            value={fetchComision()}
                            name="comision"
                        />
                    </div>
                </div>

                <Rebate
                    publicacion={this.props.publicacion}
                    userType={this.props.userType}
                    rebate={this.props.rebate}
                    idUsuario={this.props.idUsuario}
                    updateDataRebate={this.updateDataRebate}
                />

            </div>
        );
    }
}


const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
    tiposPublicacion: state.publicaciones.tiposPublicacion,
    userType: state.general.userType,
    idUsuario: state.general.userId,
    rebate: state.rebates.rebate
});

export default connect(mapStateToProps, {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchRebate
})(PrecioPago);